import { AbstractControl } from '@angular/forms';
import { of, OperatorFunction, pipe } from 'rxjs';
import { distinctUntilChanged, map, skip, startWith, switchMap } from 'rxjs/operators';

export function controlEnabled(): OperatorFunction<AbstractControl | null | undefined, boolean> {
  return pipe(
    switchMap(
      (control: AbstractControl | null | undefined) =>
        control?.statusChanges.pipe(
          map(() => control.enabled),
          startWith(control.enabled)
        ) ?? of(false)
    ),
    distinctUntilChanged()
  );
}

export function controlEnabledChanges(): OperatorFunction<
  AbstractControl | null | undefined,
  boolean
> {
  return pipe(controlEnabled(), skip(1));
}
